import { formatProductIdWithDots } from "@coworker/reusable/formatters/product.formatter";
import styles from "@coworker/apprestructured/src/media-maintenance/styles/common-media-styles.module.css";
import React from "react";
import { ItemQuantityStepper } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemQuantityStepper/ItemQuantityStepper";
import { ItemDelete } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/ItemDelete/ItemDelete";
import FixaLink from "@coworker/apprestructured/src/shared/wrappers/FixaLink/FixaLink";
import { AggregatedArticle } from "@coworker/app/src/components/RoomSettings/hooks/useAggregatedArticles";
import { Media } from "@coworker/app/src/components/RoomSettings/types/media";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNo } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNo/ItemNo";
import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";
import { Article } from "@coworker/app/src/components/RoomSettings/types/article";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";

interface MediaItemCardUnknownProps<T extends AggregatedArticle | Article> {
  itemNo: string;
  article: T;
  media: Media;
  selectArticleIdsMode?: boolean;
  badges?: ItemBadge[];
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType?: MediaItemViewType;
}

export const MediaItemCardUnknown = <T extends Article | AggregatedArticle>({
  itemNo,
  media,
  article,
  badges = [],
  selectArticleIdsMode = false,
  itemCardRenderType = ItemCardRenderType.link,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
}: MediaItemCardUnknownProps<T>) => {
  const navigationUrl =
    mediaItemViewType === MediaItemViewType.AGGREGATED_ITEM_VIEW
      ? `/mediamaintenance/medias/${article.mediaId}/articles/${article.id}/product_article_id/${article.productArticleId}`
      : `/mediamaintenance/articles/${article.id}`;
  return (
    <ItemCard badges={badges} dataTestId={"media-item-card-unknown"}>
      {itemCardRenderType === ItemCardRenderType.link ? (
        <FixaLink to={navigationUrl} className={styles["item-card-root-row"]}>
          <ItemImage imageUrl={""} />
          <div className={styles["item-card-root-column"]}>
            <ItemName name={"Unknown"} />
            <ItemNo itemNo={formatProductIdWithDots(itemNo)} />
          </div>
        </FixaLink>
      ) : (
        <div className={styles["item-card-root-row"]}>
          <ItemImage imageUrl={""} />
          <div className={styles["item-card-root-column"]}>
            <ItemName name={"Unknown"} />
            <ItemNo itemNo={formatProductIdWithDots(itemNo)} />
          </div>
        </div>
      )}

      {!selectArticleIdsMode && (
        <div className={styles["item-card-action-row"]}>
          <ItemQuantityStepper
            itemNo={itemNo}
            itemQuantityPieces={article?.nbrArticles ?? 0}
            article={article}
          />
          <ItemDelete
            itemNo={article.productArticleId}
            isItemInMultipleGroups={false}
            article={article}
            media={media}
          />
        </div>
      )}
    </ItemCard>
  );
};
